import './TagColorSection.scss';

import { coreActions } from '@sonar-software/sonar-core';
import { PresetsItem } from 'antd/es/color-picker/interface';
import { SonarText } from '@ui/text';

import { ColorPicker, Space } from 'antd';
import { COPY_SPECIFIC, TAG_COLORS } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useState } from 'react';
import { useAction, useTagReference } from '@hooks';

export interface TagColorSectionProps {
	getPopupContainer?: ((triggerNode: HTMLElement) => HTMLElement) | undefined;
	tagId?: number;
}

const presets: PresetsItem[] = [ {
	colors: TAG_COLORS,
	label: ''
} ];

export const TagColorSection: React.FC<TagColorSectionProps> = ({ getPopupContainer, tagId }) => {
	const tag = useTagReference(tagId);

	const [ currentColor, setCurrentColor ] = useState<string>(tag.hexColor ?? TAG_COLORS[ 0 ]);

	const requestPut = useAction(coreActions.requestPutCoreTagsById);

	const handleChange = useCallback((open: boolean) => {
		if (tagId && !open && tag.hexColor !== currentColor) {
			requestPut({
				...tag,
				hexColor: currentColor
			});
		}
	}, [ currentColor, requestPut, tag, tagId ]);

	return (
		<Space
			align='center'
			className='tag-color-section'
			direction='vertical'
			size={ 4 }>
			<SonarText
				size={ 16 }
				weight='semibold'>
				{ COPY_SPECIFIC.COLOR }
			</SonarText>
			<ColorPicker
				disabled={ tag.autoTagged }
				disabledAlpha
				format='hex'
				getPopupContainer={ getPopupContainer }
				onChange={ (color) => {
					setCurrentColor(color.toHexString());
				} }
				onOpenChange={ handleChange }
				presets={ presets }
				value={ currentColor } />
		</Space>
	);
};
